export enum AlternatePnType {
  AlternatePn = 0,
  ReplacementPn = 1,
}
